export const removeSingleQuotes = (str = ''): string => str.replace(/'/g, '');
